const blockedTags = new Set(['script', 'style', 'iframe', 'object', 'embed', 'link', 'meta'])
const javascriptProtocol = `java${'script:'}`

const isUnsafeAttr = (name, value) => {
  const normalizedName = name.toLowerCase()
  const normalizedValue = (value || '').trim().toLowerCase()

  if (normalizedName.startsWith('on')) {
    return true
  }

  if (
    (normalizedName === 'href' || normalizedName === 'src') &&
    normalizedValue.startsWith(javascriptProtocol)
  ) {
    return true
  }

  return false
}

export const sanitizeHtml = (html = '') => {
  const parser = new DOMParser()
  const doc = parser.parseFromString(html, 'text/html')

  blockedTags.forEach((tag) => {
    doc.querySelectorAll(tag).forEach((node) => node.remove())
  })

  doc.querySelectorAll('*').forEach((node) => {
    Array.from(node.attributes).forEach((attr) => {
      if (isUnsafeAttr(attr.name, attr.value)) {
        node.removeAttribute(attr.name)
      }

      if (attr.name === 'target' && attr.value === '_blank') {
        node.setAttribute('rel', 'noopener noreferrer')
      }
    })
  })

  return doc.body.innerHTML
}

export const extractFirstImageSrc = (html = '') => {
  const parser = new DOMParser()
  const doc = parser.parseFromString(html, 'text/html')
  const firstImage = doc.querySelector('img')
  return firstImage ? firstImage.src : null
}
